import React, { Fragment } from 'react';
import { Field } from 'formik';
import { Body, FovFieldError, FovSelect, FovOption, VerticalSpacer } from 'components';

const AIModelSelect = ({ form, isImageProvided, useAI, AIModels }) => {
  if (!isImageProvided || !useAI) {
    return null;
  }

  const aiModelOptions = AIModels.filter(model => {
    return form.values?.files && form.values.files.length > 1
      ? model.supportMultiImage
      : true;
  });

  if (!form.values.aiModel) {
    form.setFieldValue('aiModel', aiModelOptions[0].name);
  }

  return (
    <Fragment>
      <Body>AI Model</Body>
      <VerticalSpacer size={10} />

      <Field type='select' name='aiModel'>
        {data => (
          <FovSelect
            value={data.field.value}
            placeholder={data.field.value || 'Select a model'}
            onChange={(e, newVal) => {
              form.setFieldValue(data.field.name, newVal);
            }}
          >
            {aiModelOptions
              .map((model, index) => (
                <FovOption key={index} value={model.name}>
                  {model.name}
                </FovOption>
              ))}
          </FovSelect>
        )}
      </Field>

      <FovFieldError name='aiModel' />
    </Fragment>
  );
};

export default AIModelSelect;

